module.exports = __webpack_public_path__ + "static/media/bg-mletter-top.1651d652.svg";